import { render, staticRenderFns } from "./info_nao.vue?vue&type=template&id=ee53b766&scoped=true&"
import script from "./info_nao.vue?vue&type=script&lang=js&"
export * from "./info_nao.vue?vue&type=script&lang=js&"
import style0 from "./info_nao.vue?vue&type=style&index=0&id=ee53b766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee53b766",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
